// Custom JS that sync the hero image after item added

(function () {
  if (window.__onpulseStickyHeroCartDrawerCloneFix) return;
  window.__onpulseStickyHeroCartDrawerCloneFix = true;

  var clone = null;
  var lastOpenState = false;

  function isDesktop() {
    return window.matchMedia && window.matchMedia('(min-width: 1200px)').matches;
  }

  function getHeaderOffset() {
    var raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var headerHeight = parseFloat(raw) || 86;

    return headerHeight + 14;
  }

  function getCartDrawer() {
    return (
      document.querySelector('#mini-cart') ||
      document.querySelector('cart-drawer') ||
      document.querySelector('cart-notification') ||
      document.querySelector('[data-cart-drawer]') ||
      document.querySelector('.drawer--cart') ||
      document.querySelector('.drawer')
    );
  }

  function isCartDrawerOpen() {
    var html = document.documentElement;
    var drawer = getCartDrawer();

    if (html.classList.contains('lock-all') || html.classList.contains('op-cart-drawer-open')) {
      return true;
    }

    if (!drawer) return false;

    return (
      drawer.hasAttribute('open') ||
      drawer.getAttribute('aria-hidden') === 'false' ||
      drawer.classList.contains('is-open') ||
      drawer.classList.contains('is-visible') ||
      drawer.classList.contains('drawer--open') ||
      drawer.classList.contains('active')
    );
  }

  function getHeroSourceCard() {
    return document.querySelector('.op-premium-gallery-desktop__image-card--hero');
  }

  function getDesktopGallery() {
    return document.querySelector('[data-op-desktop-gallery]');
  }

  function getRail() {
    return document.querySelector('.op-premium-gallery-desktop__rail');
  }

  function removeClone() {
    if (clone && clone.parentNode) {
      clone.parentNode.removeChild(clone);
    }

    clone = null;
  }

  function createOrUpdateClone() {
    if (!isDesktop()) {
      removeClone();
      return;
    }

    if (!isCartDrawerOpen()) {
      removeClone();
      lastOpenState = false;
      return;
    }

    var sourceCard = getHeroSourceCard();
    var gallery = getDesktopGallery();
    var rail = getRail();

    if (!sourceCard || !gallery) {
      removeClone();
      return;
    }

    var sourceImg = sourceCard.querySelector('img, video');
    if (!sourceImg) {
      removeClone();
      return;
    }

    var galleryRect = gallery.getBoundingClientRect();
    var sourceRect = sourceCard.getBoundingClientRect();
    var railRect = rail ? rail.getBoundingClientRect() : null;

    var gap = 16;
    var left = galleryRect.left;
    var top = getHeaderOffset();

    var width = sourceRect.width;

    if ((!width || width < 100) && railRect) {
      width = Math.max(280, railRect.left - galleryRect.left - gap);
    }

    if (!width || width < 100) {
      width = Math.max(320, galleryRect.width * 0.68);
    }

    var height = sourceRect.height;

    if (!height || height < 300) {
      height = Math.min(Math.max(window.innerHeight * 0.84, 700), 900);
    }

    if (!clone) {
      clone = sourceCard.cloneNode(true);
      clone.classList.add('op-premium-hero-fixed-clone');
      clone.removeAttribute('hidden');
      clone.style.removeProperty('display');
      document.body.appendChild(clone);
    }

    clone.style.left = Math.round(left) + 'px';
    clone.style.top = Math.round(top) + 'px';
    clone.style.width = Math.round(width) + 'px';
    clone.style.height = Math.round(height) + 'px';
    clone.style.display = 'block';
    clone.style.visibility = 'visible';
    clone.style.opacity = '1';

    lastOpenState = true;
  }

  function scheduleUpdate() {
    window.setTimeout(createOrUpdateClone, 0);
    window.setTimeout(createOrUpdateClone, 80);
    window.setTimeout(createOrUpdateClone, 220);
  }

  document.addEventListener('cart:open', scheduleUpdate, true);

  document.addEventListener('cart:refresh', function (event) {
    if (event && event.detail && event.detail.openMiniCart) {
      scheduleUpdate();
    }
  }, true);

  document.addEventListener('cart:updated', scheduleUpdate, true);
  document.addEventListener('product:added', scheduleUpdate, true);

  document.addEventListener('click', function (event) {
    var target = event.target;

    if (!target || !target.closest) return;

    if (
      target.closest('.drawer__close-button') ||
      target.closest('[data-action="close"]') ||
      target.closest('.drawer__overlay')
    ) {
      window.setTimeout(function () {
        if (!isCartDrawerOpen()) removeClone();
      }, 120);
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      window.setTimeout(function () {
        if (!isCartDrawerOpen()) removeClone();
      }, 120);
    }
  }, true);

  window.addEventListener('resize', function () {
    if (isCartDrawerOpen()) {
      createOrUpdateClone();
    } else {
      removeClone();
    }
  });

  var observer = new MutationObserver(function () {
    var open = isCartDrawerOpen();

    if (open !== lastOpenState) {
      if (open) {
        scheduleUpdate();
      } else {
        removeClone();
      }

      lastOpenState = open;
      return;
    }

    if (open) {
      createOrUpdateClone();
    }
  });

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class', 'style']
  });

  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class', 'style']
  });
})();